import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { RefundStatusProviderService } from '../providers';
import { RefundStatus } from '../enums/refund-status';

@Pipe({
  name: 'refundStatus',
})
export class RefundStatusPipe implements PipeTransform {
  private readonly provider = inject(RefundStatusProviderService);

  public transform(status: RefundStatus): Observable<string> {
    return this.provider.labelFor(status);
  }
}
